import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import linking1 from "../Images/linking1.png";
import linking2 from "../Images/linking2.svg";
import Domainpage from "./Dapa";
const Linkingdomain = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
       
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 mb-4">
          <div className="mx-2">
            <h1 className="text-center mb-4">
              All-in-One Link Building Dashboard: Boost Your Rankings with Ease
            </h1>
            <div
          className=" mt-md-5 p-4 "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <h2
            style={{ color: "#0A3981" }}
            className="d-flex justify-content-center pt-5"
          >
            <b> Check Your Domain Authority and Age Instantly</b>
          </h2>
          <Domainpage />
        </div>
            <p className="mt-md-4 mt-2">
              Link building is SEO's strongest action on the battlefield. If
              you're looking to see your website climb up the ranks on Google
              and attain organic traffic, link building is the answer. But what
              does it really mean? Simply put, link building means getting other
              websites to link to your site. These links are like votes of
              trust, telling search engines your content is worthwhile and
              should really be shown to users.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={linking2}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h2>Understanding Linking Domains</h2>

            <p>
              It is important to collect linking domains as a component of link
              building. A linking domain is one of the many external websites
              that link to the site through spelling corrections or possible
              tips. The greater the number of high-quality domains linking to
              your website, the more likely it is that you will rank higher.
              However, link count is just one side of the attraction; link
              quality matters even more. Better, quality links can create an
              excellent impact when compared to many links from low-quality
              sites. A single link from a high-trust, authority site will build
              more impact than thousands of low-quality or spammy links.
            </p>

          
            <h3>Understand Root Domain in Seobix's</h3>

            <p>
              When it comes to smart link building, knowing the strength of the
              websites linking to you is very important. In Seobix, the Root
              Domain feature under the Linking Domain category helps you easily
              see where your backlinks are coming from at the domain level.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={linking1}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h3>What is Link Propensity in Seobix?</h3>

            <p>
              Link Propensity is a smart feature inside Seobix’s Linking Domain
              category that helps you find websites most likely to link to your
              content. Instead of randomly reaching out to hundreds of sites,
              Link Propensity predicts which domains have a higher chance of
              giving you a backlink.
            </p>

            <h3>Make Every Link Count with the Seobix</h3>

            <p>
              Manually building backlinks can be slow and overwhelming, but
              Seobix changes that. Our Link Building service Tool is designed to
              save you time while delivering better results. You can explore new
              link opportunities, monitor existing backlinks, and even learn
              from your competitors’ link profiles
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Linkingdomain;
